export const cssRules = `
	@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');
	* { box-sizing: border-box; }
	body {
		background: #f8f9fa;
		margin: 0;
		font-size: 14px;
		line-height: 1.4285em;
		color: rgba(0, 0, 0, 0.87);
		font-family: 'Nunito Sans', sans-serif;
		position: relative;
	}
	input, select {
		width: 100%;
		height: 48px;
		margin: 0 0 1em 0;
		padding: 11px;
		outline: none;
		-webkit-appearance: none;
		tap-highlight-color: rgba(255, 255, 255, 0);
		line-height: 1.21428571em;
		background: #FFFFFF;
		border: 1px solid rgba(0, 0, 0, 0.16);
		color: rgba(0, 0, 0, 0.87);
		border-radius: 4px;
		-webkit-box-shadow: 0 0 0 0 transparent inset;
		box-shadow: 0 0 0 0 transparent inset;
		-webkit-transition: color 0.1s ease, border-color 0.1s ease;
		transition: color 0.1s ease, border-color 0.1s ease;
		font-family: "Nunito Sans", sans-serif;
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 20px;
		align-items: center;
		height: 56px;
		padding: 15px 0px 0px 12px;
	}
	input[type="text"]:not(.error):focus,
	input[type="tel"]:not(.error):focus,
	select:not(.error):focus {
		color: rgba(0, 0, 0, 0.95);
		border-color: #85B7D9;
		border-radius: 0.28571429rem;
		background: #FFFFFF;
		-webkit-box-shadow: 0 0 0 0 rgb(34 36 38 / 35%) inset;
		box-shadow: 0 0 0 0 rgb(34 36 38 / 35%) inset;
	}
	input[type="text"]:not(.error):focus {
		max-height: 100%;
  		max-width: 100%;
	}
	.cardNumber input::placeholder,
	.cvv2Codeinput input::placeholder,
	.postalCodezipcode input::placeholder,
	.streetAddress input::placeholder,
	.postalCode input::placeholder {
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: rgba(0, 0, 0, 0.87);
		font-family: "Nunito Sans", sans-serif;
	}
	.postalCodezipcode {
		margin-top:16px;
	}
	.streetAddress {
		margin-top:8px;
	}
	.submitButton {
		margin-top:8px;
	}
	label {
		display: block;
		margin: 0 0 0.28571429rem 0;
		color: rgba(0, 0, 0, 0.60);
		font-size: 14px;
		font-weight: 400;
		text-transform: none;
		line-height: 20px;
		font-family: "Nunito Sans", sans-serif;
		
	}
	label:first-child {
		position: absolute;
		left: 12px;
		top: 8px;
	}
	a { color: #0078d4; text-decoration: none; }
	a:hover { color: #006abb; }
	/* Button styles */
	input[type="submit"] {
			cursor: pointer;
			display: block;
			min-height: 1em;
			outline: none;
			border: none;
			vertical-align: baseline;
			font-family: "Nunito Sans", sans-serif;
			margin: 0;
			padding: 0.78571429em 1.5em 0.78571429em;
			text-transform: none;
			font-weight: bold;
			line-height: 1em;
			font-style: normal;
			text-align: center;
			text-decoration: none;
			border-radius: 0.28571429rem;
			-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;
			-webkit-transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, background 0.1s ease, -webkit-box-shadow 0.1s ease;
			transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, background 0.1s ease, -webkit-box-shadow 0.1s ease;
			transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
			transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease, -webkit-box-shadow 0.1s ease;
			will-change: '';
			-webkit-tap-highlight-color: transparent;
			color: #FFFFFF;
			text-shadow: none;
			background-image: none;
			-webkit-box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
			box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
	}
	input[type="submit"] { background-color: #0078d4; }
	input[type="submit"]:hover { background-color: #006abb; }
	input[type="submit"]:focus { background-color: #0061ab; }
	input[type="submit"]:active { background-color: #006abb; }
	input.error, select.error { border-color: #E31C1C;}
	input.error, select.error { margin-bottom: 0.25em; }
	label.error { color: #E31C1C; margin-bottom: 1em; line-height: 16px; font-weight: 400; }
	select:nth-child(2) { width: 50%; }
	select:nth-child(3) { width: 48%; float: right; }
	div[helpactive="1"] { margin-top: -0.75em; margin-bottom: 1em; }
	#i4go_cvv2Code-label small {
	color: transparent;
	display: block;
	margin-top: 30px;
	}
	#i4go_cardholderName-label {
		display: none !important;
	}
	#i4go_cvv2Code-label a {
		color: #0E5BF3;
		text-transform: capitalize;
	}
	#i4go_submit {
		background-color: #0E5BF3;
		border-color: #0E5BF3;
		font-size: 14px;
		text-transform: uppercase;
		border-radius: 64px;
		height: 40px;
		margin-bottom:6px;
		font-weight:700;
		padding: 8px 15px;
		font-family: "Nunito Sans", sans-serif;
	}
	#i4go_submit-label, .container ~ p { display: none; }
	.ui-widget.ui-widget-content { border: none !important; }
	::-webkit-input-placeholder { color: #848484; }
	::-moz-placeholder { color: #848484; }
	:-ms-input-placeholder { color: #848484; }
	input::placeholder { color: #848484; }
	.cardHolderName {
		border-bottom: 1px solid #cccccc;
	}

	.cardNumber {
		position: relative;
		input {
			height: 56px;
			padding: 15px 0px 0px 12px;
		}
	}
	.optional-field {
		position: relative;
	}
	.cardholderName {
		input {
			padding:8px 16px;
			line-height: 24px;
		}	
	}
	.expirationYear input::aria-label
	{  
		color:'red';
	} 
	#cvv2Code-error {
		padding-top:20px;
	}
	.cvv2info {
	 	padding-top:20px;
	}
`;
